// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PASSWORD_RESET_CHOOSE_EMAIL = "Obnov si heslo p\u0159es email nebo p\u0159ihla\u0161ovac\u00ed jm\u00e9no";
export const PASSWORD_RESET_CHOOSE_SMS = "Obnov si heslo p\u0159es telefon (mus\u00ed\u0161 m\u00edt na kon\u00edku ov\u011b\u0159en\u00e9 \u010d\u00edslo)";
export const PASSWORD_RESET_DID_YOU_FORGET_PASSWORD = "Zapomn\u011bla jsi heslo?";
